import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

export const useDashboard = () => {
    const [isComparing, setIsComparing] = useState<boolean>(false);
    const [trendTimeframe, setTrendTimeframe] = useState<string>('daily');
    const [dateRange, setDateRange] = useState<any>([dayjs().startOf('month'), dayjs().endOf('month')]);
    const [compareDateRange, setCompareDateRange] = useState<any>(null);
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    useEffect(() => {
        if (isComparing && dateRange && dateRange[0] && dateRange[1]) {
            const diff = dateRange[1].diff(dateRange[0], 'day') + 1;
            setCompareDateRange([dateRange[0].subtract(diff, 'day'), dateRange[1].subtract(diff, 'day')]);
        }
    }, [isComparing, dateRange]);

    const compareLabel = compareDateRange && compareDateRange[0] ? compareDateRange[0].format('MMM YYYY') : 'Apr 2026';

    const handleDownloadReport = () => {
        // TODO: Fetch actual data for the report instead of using mock data
        const mockDashboardData = { merchants: [] as any[] };
        const { merchants } = mockDashboardData;
        const headers = ["Merchant Name", "Email", "Wallet Balance", "Commission (May)", "Radius (May)", "Users (May)", "Upcoming Charges", "Status"];
        const rows = merchants.map(m => [
            `"${m.name}"`,
            `"${m.email}"`,
            m.walletBalance,
            m.commission,
            m.radius,
            m.users,
            m.upcomingCharges,
            `"${m.status}"`
        ]);

        const csvContent = [
            headers.join(","),
            ...rows.map(row => row.join(","))
        ].join("\n");

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'merchant_billing_report.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return {
        isComparing,
        setIsComparing,
        trendTimeframe,
        setTrendTimeframe,
        dateRange,
        setDateRange,
        compareDateRange,
        setCompareDateRange,
        isFilterDrawerOpen,
        setIsFilterDrawerOpen,
        compareLabel,
        handleDownloadReport
    };
};
